import { Button } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";
import { gUpgradeIndicatorIcon, gWhiteLabel } from "@coreapp/whitelabel/brand";
import { enumBrand } from "@coreapp/constants";
import { useMainNavItems } from "@/appComponents/Navigation/MainNavigation/useMainNavItems";

const PlanButtonIcon = () => {
  const { namedOptions } = useMainNavItems();
  const item = namedOptions["planning"];
  if (!item) return null;

  const isLocked = !!item.showUpgrade;
  const iconName = isLocked ? gUpgradeIndicatorIcon : item.icon;

  return (
    <div className="ocn-plan-button">
      <Button
        dataTestId={isLocked ? "plan-button-upgrade-trigger-btn" : "plan-button-trigger-btn"}
        isFullWidth={true}
        iconAlignEnd={false}
        iconOnly={false}
        className={isLocked ? "ocn-plan-button-trigger--isolved-gated" : undefined}
        iconProps={{
          modifier: "white",
          name: iconName,
          title: appstr("Plan")
        }}
        onClick={isLocked ? undefined : item.onClick}
        modifier="secondary"
        type="button"
      >
        {appstr("Plan")}
      </Button>
    </div>
  );
};

const PlanButton = () => (gWhiteLabel === enumBrand.isolved ? <PlanButtonIcon /> : null);

export default PlanButton;
